import * as sx from "./key-value-list.sx";
import { KeyValuePair } from "./key-value-pair";
import type { KeyValueContainerProps } from "./types";

export function KeyValueList({
  "data-testid": dataTestId,
  items,
  className,
  labelTransform,
}: KeyValueContainerProps) {
  return (
    <sx.List data-testid={dataTestId} className={className}>
      {items.map((item, index) => (
        <KeyValuePair
          key={index}
          {...item}
          component="li"
          labelTransform={labelTransform}
        />
      ))}
    </sx.List>
  );
}

KeyValueList.slots = KeyValuePair.slots;
